import logo from '../../assets/evelandMediaLogo.svg';
import './header.css';
import Socialmedia from "../socialMedia/Socialmedia";
import {Link} from "react-router-dom";
const Header = () => {
    return (
        <header>
            <Link to="/"><img className="logo" src={logo} alt="evelandmedia Logo" /></Link>
            <Socialmedia />
        </header>
    )
}

export default Header;